
















































































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AuditItemWithId } from "@auditcloud/shared/lib/utils/audit/types";
import { api as auditApi } from "@/store/modules/audit";
import { AuditItemProperties } from "@/store/modules/audit/types";
import { Action, Getter } from "vuex-class";
import AActionBar from "@/components/widgets/AActionBar.vue";
import AAuditItemTagsDialog from "@/components/dialogs/AAuditItemTagsDialog.vue";
import AAuditItemNoteDialog from "@/components/dialogs/AAuditItemNoteDialog.vue";
import { idable } from "@auditcloud/shared/lib/types/common";
import { AuditItem } from "@auditcloud/shared/lib/schemas";

@Component({
  components: { AActionBar, AAuditItemTagsDialog, AAuditItemNoteDialog },
})
export default class ASelfAssessmentActionBar extends Vue {
  isEditingTags: boolean = false;
  isEditingNote: boolean = false;

  @Prop({ type: Array, required: true })
  readonly auditItemIds!: Array<AuditItemWithId["id"]>;

  @Getter(auditApi.getters.getAuditItems, { namespace: auditApi.namespace })
  getAuditItems!: idable<AuditItem>[];

  @Getter(auditApi.getters.getAuditItemProperties, {
    namespace: auditApi.namespace,
  })
  getAuditItemProperties!: Map<AuditItemWithId["id"], AuditItemProperties>;

  @Getter(auditApi.getters.getAuditIsBulkUpdating, {
    namespace: auditApi.namespace,
  })
  auditIsBulkUpdating!: boolean;

  get auditItems() {
    return this.getAuditItems.filter(auditItem =>
      this.auditItemIds.includes(auditItem.id)
    );
  }

  get selectionHasAuditItemsWithSelfAssessmentDisabled(): boolean {
    return this.auditItemIds.some(
      id => !this.getAuditItemProperties.get(id)?.isSelfAssessmentEnabled
    );
  }

  get selectionHasAuditItemsWithSelfAssessmentEnabled(): boolean {
    return this.auditItemIds.some(
      id => this.getAuditItemProperties.get(id)?.isSelfAssessmentEnabled
    );
  }

  @Action(auditApi.actions.manuallyAddAuditItemsToSelfAssessment, {
    namespace: auditApi.namespace,
  })
  manuallyAddAuditItemsToSelfAssessment!: (
    auditItemIds: Array<AuditItemWithId["id"]>
  ) => Promise<void>;

  @Action(auditApi.actions.manuallyRemoveAuditItemsFromSelfAssessment, {
    namespace: auditApi.namespace,
  })
  manuallyRemoveAuditItemsFromSelfAssessment!: (
    auditItemIds: Array<AuditItemWithId["id"]>
  ) => Promise<void>;

  async toggleSelfAssessment(
    auditItemIds: Array<AuditItemWithId["id"]>,
    enable: boolean
  ) {
    enable
      ? await this.manuallyAddAuditItemsToSelfAssessment(auditItemIds)
      : await this.manuallyRemoveAuditItemsFromSelfAssessment(auditItemIds);
  }

  deselectAll() {
    this.$emit("deselect-all");
  }
}
